var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhpLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    className: "nav-logo",
    viewBox: "0 0 90 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M90,10.8c0,6-4.8,10.8-10.8,10.8h-7.4v12.6h-8.5V0h15.8C85.2,0,90,4.9,90,10.8z M77.8,7.1h-5.9  v7.1h5.9c1.9,0,3.4-1.7,3.4-3.5C81.2,8.8,79.7,7.1,77.8,7.1z M49.9,0v13.9H38.1V0h-8.5v34.3h8.5V21.7h11.8v12.6h8.5V0H49.9z   M26.3,25c0,5.7-5.1,9.3-10.5,9.3H0V0h15.3c5.6,0,10.2,4.1,10.2,9.2c0,4-1.9,6.2-4.5,7.8C24,18.3,26.3,20.2,26.3,25z M14.1,20.5H8.5  v6.6h5.6c2.2,0,3.4-1.5,3.4-3.3C17.5,22,15.9,20.5,14.1,20.5z M13.3,7.1H8.5v7.1h4.8c2.2,0,3.4-1.7,3.4-3.5  C16.7,8.8,15.5,7.1,13.3,7.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhpLogo);
export default __webpack_public_path__ + "static/media/bhp-logo.694e81173ffee6e8cec4b095601fdd47.svg";
export { ForwardRef as ReactComponent };